export default __webpack_public_path__ + "static/media/logo.3a658771.png";